// libs
import { createSelector } from 'reselect';
import get from 'lodash/get';

// defs
import { RemoteConfigState } from './types';

export const remoteConfigs = (state: { remoteConfigs: RemoteConfigState }): RemoteConfigState =>
  state.remoteConfigs;

export const getRemoteConfigs = createSelector(
  [remoteConfigs],
  (remoteConfigData) => remoteConfigData
);

export const getRemoteConfig = <T extends keyof RemoteConfigState>(
  state: { remoteConfigs: RemoteConfigState },
  config: T,
  defaultValue?: RemoteConfigState[T]
): RemoteConfigState[T] => {
  const remoteConfigsData = getRemoteConfigs(state);
  const value = get(remoteConfigsData, config);

  // Fallback priority: state value -> defaultValue param
  // Note: SSR always hydrates with full config from server/middleware/remoteConfig.ts
  // so defaultValue is only used for edge cases or non-SSR scenarios
  if (value !== undefined) {
    return value;
  }

  return defaultValue as RemoteConfigState[T];
};
